if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}


/* ============================================================
   VF / Pebble & Wick — Cinematic Product Modal Enhancements
   Safe layer on top of Dawn product-modal.js.
   Keeps modal opening, active media focus, scroll positioning and deferred media loading intact.
   ============================================================ */

(() => {
  const ProductModalElement = customElements.get('product-modal');
  if (!ProductModalElement || ProductModalElement.prototype.__vfCinematicPatched) return;

  ProductModalElement.prototype.__vfCinematicPatched = true;

  const originalShow = ProductModalElement.prototype.show;
  const originalHide = ProductModalElement.prototype.hide;
  const originalShowActiveMedia = ProductModalElement.prototype.showActiveMedia;

  const root = document.documentElement;

  const setProductModalState = (modal, state, detail = {}) => {
    modal.dataset.vfProductModalState = state;

    modal.classList.toggle('vf-product-modal-opening', state === 'opening');
    modal.classList.toggle('vf-product-modal-open', state === 'open');
    modal.classList.toggle('vf-product-modal-closing', state === 'closing');
    modal.classList.toggle('vf-product-modal-media-ready', state === 'media-ready');

    root.classList.toggle('vf-product-modal-is-open', state === 'opening' || state === 'open' || state === 'media-ready');
    document.body?.classList.toggle('vf-product-modal-is-open', state === 'opening' || state === 'open' || state === 'media-ready');

    modal.dispatchEvent(
      new CustomEvent(`vf:product-modal-${state}`, {
        bubbles: true,
        detail
      })
    );
  };

  const getActiveMediaId = (modal) => modal.openedBy?.getAttribute('data-media-id') || null;

  const markModalMedia = (modal) => {
    modal.querySelectorAll('[data-media-id]').forEach((media, index) => {
      media.classList.add('vf-product-modal__media');
      media.style.setProperty('--vf-product-modal-media-index', index);
      media.classList.toggle('vf-product-modal__media-active', media.classList.contains('active'));
    });
  };

  const pulseActiveMedia = (media) => {
    if (!media) return;

    media.classList.remove('vf-product-modal__media-pulse');
    void media.offsetWidth;
    media.classList.add('vf-product-modal__media-pulse');

    window.setTimeout(() => {
      media.classList.remove('vf-product-modal__media-pulse');
    }, 820);
  };

  ProductModalElement.prototype.show = function vfShow(opener) {
    const mediaId = opener?.getAttribute('data-media-id') || null;

    this.classList.add('vf-product-modal-enhanced');
    setProductModalState(this, 'opening', {
      opener,
      mediaId
    });

    const result = originalShow.call(this, opener);

    window.requestAnimationFrame(() => {
      markModalMedia(this);

      setProductModalState(this, 'open', {
        opener,
        mediaId
      });
    });

    return result;
  };

  ProductModalElement.prototype.hide = function vfHide() {
    const mediaId = getActiveMediaId(this);

    setProductModalState(this, 'closing', {
      mediaId,
      opener: this.openedBy
    });

    const result = originalHide.call(this);

    window.setTimeout(() => {
      setProductModalState(this, 'closed', {
        mediaId
      });
    }, 260);

    return result;
  };

  ProductModalElement.prototype.showActiveMedia = function vfShowActiveMedia() {
    const mediaId = getActiveMediaId(this);
    const result = originalShowActiveMedia.call(this);
    const activeMedia = mediaId ? this.querySelector(`[data-media-id="${mediaId}"]`) : this.querySelector('[data-media-id].active');

    markModalMedia(this);

    if (activeMedia) {
      activeMedia.classList.add('vf-product-modal__media-active');
      pulseActiveMedia(activeMedia);
    }

    setProductModalState(this, 'media-ready', {
      mediaId,
      activeMedia
    });

    this.dispatchEvent(
      new CustomEvent('vf:product-modal-active-media', {
        bubbles: true,
        detail: {
          mediaId,
          activeMedia
        }
      })
    );

    return result;
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('product-modal').forEach((modal) => {
      modal.classList.add('vf-product-modal-enhanced');
      markModalMedia(modal);
    });
  }, { once: true });

  document.addEventListener('click', (event) => {
    const opener = event.target.closest?.('[data-media-id]');
    if (!opener || !opener.closest?.('media-gallery, .product__media-wrapper')) return;

    opener.classList.add('vf-product-modal-opener-clicked');

    window.setTimeout(() => {
      opener.classList.remove('vf-product-modal-opener-clicked');
    }, 520);
  });

  document.addEventListener('keyup', (event) => {
    if (event.code?.toUpperCase() !== 'ESCAPE') return;

    document.querySelectorAll('product-modal[open], product-modal .active').forEach((element) => {
      const modal = element.closest?.('product-modal') || element;
      modal.classList?.add('vf-product-modal-escape');

      window.setTimeout(() => {
        modal.classList?.remove('vf-product-modal-escape');
      }, 360);
    });
  });
})();
